<template>
  <div class="page__data_center b-page" style="padding-top: 10px; min-height: 100vh">
    <div id="select-block" style="background-color:white; padding:10px 10px; overflow: hidden;">
      <div style="padding-left: 5px">
        <p class="text-primary" style="font-weight: bold; font-size: 20px">{{ $t('menu.business_insights') }}</p>
      </div>

      <el-row id="fixed-select"
              style="z-index: -1; padding: 20px 15px 10px 0; position: fixed; top: 0; right: 13px;background-color: #f6f6f6;">
        <el-col :sm="16" style="padding-left: 10px">
          <div style="display: inline-block; margin-right: 10px">
            <shop-select v-model="shopee_shop.selected" :shopee_shop_list="shopee_shop.list"
                         :disabled="loading.get_data"></shop-select>
          </div>
          <div style="display: inline-block">
            <el-select v-model="date_option" value="" size="small" :disabled="!shopee_shop.selected || loading.get_data"
                       @change="m__update_data">
              <el-option v-for="item in date_options" :key="item.period" :value="item.period"
                         :label="item.label"></el-option>
            </el-select> &nbsp;&nbsp;
            <el-date-picker
                id="date-picker-data-center"
                v-model="date"
                :type="m__date_option().date_type"
                :format="m__date_option().format"
                :picker-options="{firstDayOfWeek: 1, disabledDate(time) {return time.getTime() > Date.now()}}"
                :placeholder="$t('input.select_time')"
                :start-placeholder="$t('input.start_time')"
                end-:placeholder="$t('base.select_end_time')"
                size="small"
                :disabled="!shopee_shop.selected || !m__date_option().show_date || loading.get_data"
                @change="m__update_data">
            </el-date-picker>
          </div>
        </el-col>
        <el-col :sm="8" class="text-right" style="padding-right: 5px">
          <el-button size="mini" @click="m__show_compare_data">
            {{ $t('base.compare_data') }}
            <strong style="font-weight: 700" v-if="is_compare_data" class="text-success">[ ON ]</strong>
            <strong style="font-weight: 700" v-else class="text-danger">[ OFF ]</strong>
          </el-button>
          <el-button size="small" type="success" icon="el-icon-refresh" @click="m__update_data()"
                     :loading="loading.get_data" :disabled="!shopee_shop.selected">
            {{ $t('base.reload_data') }}
          </el-button>
        </el-col>
      </el-row>

      <el-row style="margin-top: 20px; padding-left: 5px">
        <el-col :sm="16">
          <div style="display: inline-block; margin-right: 10px">
            <shop-select v-model="shopee_shop.selected" :shopee_shop_list="shopee_shop.list"
                         :disabled="loading.get_data"></shop-select>
          </div>
          <div style="display: inline-block">
            <el-select v-model="date_option" value="" size="small" :disabled="!shopee_shop.selected || loading.get_data"
                       @change="m__update_data">
              <el-option v-for="item in date_options" :key="item.period" :value="item.period"
                         :label="item.label"></el-option>
            </el-select> &nbsp;&nbsp;
            <el-date-picker
                id="date-picker-data-center"
                v-model="date"
                :type="m__date_option().date_type"
                :format="m__date_option().format"
                :picker-options="{firstDayOfWeek: 1, disabledDate(time) {return time.getTime() > Date.now()}}"
                :placeholder="$t('input.select_time')"
                :start-placeholder="$t('input.start_time')"
                end-:placeholder="$t('base.select_end_time')"
                size="small"
                :disabled="!shopee_shop.selected || !m__date_option().show_date || loading.get_data"
                @change="m__update_data">
            </el-date-picker>
          </div>
        </el-col>
        <el-col :sm="8" class="text-right" style="padding-right: 5px">
          <el-button size="mini" @click="m__show_compare_data">
            {{ $t('base.compare_data') }}
            <strong style="font-weight: 700" v-if="is_compare_data" class="text-success">[ ON ]</strong>
            <strong style="font-weight: 700" v-else class="text-danger">[ OFF ]</strong>
          </el-button>
          <el-button size="small" type="success" icon="el-icon-refresh" @click="m__update_data()"
                     :loading="loading.get_data" :disabled="!shopee_shop.selected">
            {{ $t('base.reload_data') }}
          </el-button>
        </el-col>
      </el-row>
    </div>

    <div id="first-block" v-loading="loading.get_data"
         style="background-color:white; padding: 5px 10px 10px 10px; overflow: hidden; margin-top: 10px">
      <el-row style="padding-right: 10px; height: 20px;">
        <el-col :sm="12" style="padding-top: 5px; padding-left: 5px">
          <strong v-if="ads_minimize" style="font-size: 15px !important;">{{ $t('base.overview_metrics') }}: </strong>
          <strong v-else>&nbsp;</strong>
        </el-col>
        <el-col :sm="12" class="text-right">
          <el-tooltip class="item" effect="dark" content="Thu nhỏ" placement="top-start">
            <a href="javascript:void(0)" @click="ads_minimize = !ads_minimize">
              <i :class="`el-icon-arrow-${ads_minimize ? 'down' : 'up'}`" style="font-size: 20px"></i>
            </a>
          </el-tooltip>
        </el-col>
      </el-row>
      <el-row v-if="!ads_minimize" style="padding-left: 5px">
        <el-col :sm="24">
          <el-tabs v-model="selected_tab">
            <el-tab-pane :label="$t('ads.all_cpc_ads')" name="new_cpc_homepage"></el-tab-pane>
            <el-tab-pane :label="$t('ads.product_ads')" name="product_homepage"></el-tab-pane>
            <el-tab-pane :label="$t('ads.shop_ads')" name="shop_homepage"></el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
      <div v-if="!ads_minimize">
        <div style="padding: 10px 0; display: flex">
          <div style="flex: 1">
            <span style="font-size: 15px; font-weight: 700">{{ $t('base.overview_metrics') }}:</span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span class="circle" :style="`background-color: rgb(54, 127, 227)`"></span>
            <span style="font-size: 15px">CPS:</span>
            <span style="font-size: 15px; font-weight: 700">
              {{ m__calculate_metric('CPS') | currency }}
              {{ m__currency() }}
            </span>
          </div>
          <div style="flex: 2; text-align: right">
            <template v-if="['new_cpc_homepage', 'product_homepage', 'shop_homepage'].includes(selected_tab)">
              <i :class="loading.marketing_report_file ? 'el-icon-loading' : 'el-icon-download'"
                 class="text-warning"></i>
              <a :loading="loading.export_report" href="javascript:void(0)" class="text-warning"
                 @click="m__download_pas_ads_report(selected_tab)"
                 style="text-decoration: underline !important; font-size: 13px; font-weight: bold">{{
                  $t('base.export_data')
                }}</a>
              &nbsp;&nbsp;
              <router-link to="/marketing/pas" class="text-primary"
                           style="text-decoration: underline !important; font-size: 13px; font-weight: bold">
                {{ $t('center.go_to_shopee_ads') }} >>
              </router-link>
            </template>
          </div>
        </div>

        <ComponentMetric v-if="selected_tab === 'new_cpc_homepage'" :metrics="new_cpc_homepage_metrics"
                         :is_compare="is_compare_campaign" :compare_metrics="new_cpc_homepage_metrics_compare"
                         :reports="new_cpc_homepage_reports" :shop="shop"
                         :show_checkout="true"></ComponentMetric>

        <ComponentMetric v-if="selected_tab === 'product_homepage'" :metrics="product_homepage_metrics"
                         :is_compare="is_compare_campaign" :compare_metrics="product_homepage_metrics_compare"
                         :reports="product_homepage_reports" :shop="shop"
                         :show_checkout="true"></ComponentMetric>

        <ComponentMetric v-if="selected_tab === 'shop_homepage'" :metrics="shop_homepage_metrics"
                         :is_compare="is_compare_campaign" :compare_metrics="shop_homepage_metrics_compare"
                         :reports="shop_homepage_reports" :shop="shop"
                         :show_checkout="true"></ComponentMetric>

        <ComponentMetric v-if="selected_tab === 'all'" :metrics="total_metrics" :reports="total_reports"
                         :show_checkout="true" :shop="shop"></ComponentMetric>

        <ComponentMetric v-if="selected_tab === 'keyword_ads'" :metrics="search_ads_metrics"
                         :reports="search_ads_reports" :show_checkout="true" :shop="shop"></ComponentMetric>

        <ComponentMetric v-if="selected_tab === 'targeting_ads'" :metrics="targeting_ads_metrics"
                         :reports="targeting_ads_reports" :show_checkout="true" :shop="shop"></ComponentMetric>

        <ComponentMetric v-if="selected_tab === 'boost_ads'" :metrics="boost_ads_metrics"
                         :reports="boost_ads_reports" :show_checkout="true" :shop="shop"></ComponentMetric>
      </div>
    </div>

    <div v-loading="loading.get_data"
         style="background-color:white; padding: 5px 10px 10px 10px; overflow: hidden; margin-top: 10px">
      <el-row style="padding-right: 10px; height: 20px;">
        <el-col :sm="12" style="padding-top: 5px; padding-left: 5px">
          <strong v-if="total_minimize" style="font-size: 15px !important;">{{ $t('base.overview_metrics') }} </strong>
          <strong v-else>&nbsp;</strong>
        </el-col>
        <el-col :sm="12" class="text-right">
          <el-tooltip class="item" effect="dark" content="Thu nhỏ" placement="top-start">
            <a href="javascript:void(0)" @click="total_minimize = !total_minimize">
              <i :class="`el-icon-arrow-${total_minimize ? 'down' : 'up'}`" style="font-size: 20px"></i>
            </a>
          </el-tooltip>
        </el-col>
      </el-row>
      <div v-if="!total_minimize" style="margin-top: 10px">
        <el-row>
          <el-col :sm="12" style="padding-left: 5px">
            <p><strong style="font-size: 15px !important;">{{ $t('base.overview_metrics') }} </strong>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="circle" :style="`background-color: rgb(54, 127, 227)`"></span><span
                  style="font-size: 15px">CPS:</span>
              <span style="font-size: 15px; font-weight: 700"> {{ total_cps | currency }}{{ m__currency() }} </span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="circle" :style="`background-color: rgb(54, 127, 227)`"></span><span
                  style="font-size: 15px">CIR:</span>
              <span style="font-size: 15px; font-weight: 700"> {{ total_cir.toFixed(2) }}% </span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span style="font-size: 15px; font-weight: 700">({{ $t('center.use_cost_ads') }})</span>
            </p>
          </el-col>
          <el-col :sm="12" class="text-right" style="padding-right: 5px">
            <el-select v-model="order_type" value="" size="mini" :disabled="!shopee_shop.selected"
                       @change="m__update_data">
              <el-option :value="''" :label="$t('center.placed_order')"></el-option>
              <el-option :value="'confirmed'" :label="$t('center.confirmed_order')"></el-option>
              <el-option :value="'paid'" :label="$t('center.paid_order')"></el-option>
            </el-select>
            &nbsp;&nbsp;
            <el-button size="mini" icon="el-icon-download" @click="m__download_excel_file"
                       :disabled="!shopee_shop.selected "> {{ $t('base.export_data') }}
            </el-button>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px">
          <el-col :sm="4" style="padding: 0 5px">
            <div class="important-box" @click="m__select_key('place_gmv')"
                 :style="m__in_selected_key('place_gmv') ? `border-top: 4px solid ${key_list['place_gmv'].color}` : ''">
              <span style="font-weight: 700">{{ $t('center.sales') }}</span><br>
              <div style="width: 100%; height: 5px"></div>
              <span style="font-weight: 700; font-size: 23px; margin-top: 10px">
                {{ m__calculate(m__key_metrics_get_value('place_gmv')) | currency }}
              </span>
              <strong style="font-size: 18px">{{ m__currency() }}</strong><br>
              <div style="width: 100%; height: 5px"></div>
              <template v-if="is_compare_data">
                <strong class="text-danger key_metrics_compare">
                  {{ m__key_metrics_get_value_compare('place_gmv') | currency }}
                </strong>
                <div style="width: 100%; height: 5px"></div>
              </template>
              <el-row>
                <el-col :sm="15">
                  <span
                      style="font-size: 11px !important; line-height: 14px; color: #999;">{{
                      m__get_date_option_compare()
                    }}</span>
                </el-col>
                <el-col :sm="9" class="text-right">
                  <span v-if="m__key_metrics_get_chain_ratio('place_gmv') >= 0"
                        style="font-size: 11px !important; font-weight: 700" class="text-success">
                    +{{ m__key_metrics_get_chain_ratio('place_gmv') }}%
                  </span>
                  <span v-else style="font-size: 11px !important; font-weight: 700" class="text-danger">
                    {{ m__key_metrics_get_chain_ratio('place_gmv') }}%
                  </span>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :sm="4" style="padding: 0 5px">
            <div class="important-box" @click="m__select_key('place_orders')"
                 :style="m__in_selected_key('place_orders') ? `border-top: 4px solid ${key_list['place_orders'].color}` : ''">
              <span style="font-weight: 700">{{ $t('center.orders') }}</span><br>
              <div style="width: 100%; height: 5px"></div>
              <span style="font-weight: 700; font-size: 23px; margin-top: 10px">
                {{ m__key_metrics_get_value('place_orders') | currency }}
              </span>
              <strong style="font-size: 18px"></strong><br>
              <div style="width: 100%; height: 5px"></div>
              <template v-if="is_compare_data">
                <strong class="text-danger key_metrics_compare">
                  {{ m__key_metrics_get_value_compare('place_orders') | currency }}
                </strong>
                <div style="width: 100%; height: 5px"></div>
              </template>
              <el-row>
                <el-col :sm="15">
                  <span
                      style="font-size: 11px !important; line-height: 14px; color: #999;">{{
                      m__get_date_option_compare()
                    }}</span>
                </el-col>
                <el-col :sm="9" class="text-right">
                  <span v-if="m__key_metrics_get_chain_ratio('place_orders') >= 0"
                        style="font-size: 11px !important; font-weight: 700" class="text-success">
                    +{{ m__key_metrics_get_chain_ratio('place_orders') }}%
                  </span>
                  <span v-else style="font-size: 11px !important; font-weight: 700" class="text-danger">
                    {{ m__key_metrics_get_chain_ratio('place_orders') }}%
                  </span>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :sm="4" style="padding: 0 5px">
            <div class="important-box" @click="m__select_key('shop_uv_to_placed_buyers_rate')"
                 :style="m__in_selected_key('shop_uv_to_placed_buyers_rate') ? `border-top: 4px solid ${key_list['shop_uv_to_placed_buyers_rate'].color}` : ''">
              <span style="font-weight: 700">{{ $t('center.conversions_rate') }}</span><br>
              <div style="width: 100%; height: 5px"></div>
              <span style="font-weight: 700; font-size: 23px; margin-top: 10px">
                {{ (m__key_metrics_get_value('shop_uv_to_placed_buyers_rate') * 100).toFixed(2) }}
              </span>
              <strong style="font-size: 18px">%</strong><br>
              <div style="width: 100%; height: 5px"></div>
              <template v-if="is_compare_data">
                <strong class="text-danger key_metrics_compare">
                  {{ (m__key_metrics_get_value_compare('shop_uv_to_placed_buyers_rate') * 100).toFixed(2) }}%
                </strong>
                <div style="width: 100%; height: 5px"></div>
              </template>
              <el-row>
                <el-col :sm="15">
                  <span
                      style="font-size: 11px !important; line-height: 14px; color: #999;">{{
                      m__get_date_option_compare()
                    }}</span>
                </el-col>
                <el-col :sm="9" class="text-right">
                  <span v-if="m__key_metrics_get_chain_ratio('shop_uv_to_placed_buyers_rate') >= 0"
                        style="font-size: 11px !important; font-weight: 700" class="text-success">
                    +{{ m__key_metrics_get_chain_ratio('shop_uv_to_placed_buyers_rate') }}%
                  </span>
                  <span v-else style="font-size: 11px !important; font-weight: 700" class="text-danger">
                    {{ m__key_metrics_get_chain_ratio('shop_uv_to_placed_buyers_rate') }}%
                  </span>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :sm="4" style="padding: 0 5px">
            <div class="important-box" @click="m__select_key('place_sales_per_order')"
                 :style="m__in_selected_key('place_sales_per_order') ? `border-top: 4px solid ${key_list['place_sales_per_order'].color}` : ''">
              <span style="font-weight: 700">{{ $t('center.sales_on_orders') }}</span><br>
              <div style="width: 100%; height: 5px"></div>
              <span style="font-weight: 700; font-size: 23px; margin-top: 10px">
                {{ m__calculate(m__key_metrics_get_value('place_sales_per_order')) | currency }}
              </span>
              <strong style="font-size: 18px">{{ m__currency() }}</strong><br>
              <div style="width: 100%; height: 5px"></div>
              <template v-if="is_compare_data">
                <strong class="text-danger key_metrics_compare">
                  {{ m__key_metrics_get_value_compare('place_sales_per_order') | currency }}
                </strong>
                <div style="width: 100%; height: 5px"></div>
              </template>
              <el-row>
                <el-col :sm="15">
                  <span
                      style="font-size: 11px !important; line-height: 14px; color: #999;">{{
                      m__get_date_option_compare()
                    }}</span>
                </el-col>
                <el-col :sm="9" class="text-right">
                  <span v-if="m__key_metrics_get_chain_ratio('place_sales_per_order') >= 0"
                        style="font-size: 11px !important; font-weight: 700" class="text-success">
                    +{{ m__key_metrics_get_chain_ratio('place_sales_per_order') }}%
                  </span>
                  <span v-else style="font-size: 11px !important; font-weight: 700" class="text-danger">
                    {{ m__key_metrics_get_chain_ratio('place_sales_per_order') }}%
                  </span>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :sm="4" style="padding: 0 5px">
            <div class="important-box" @click="m__select_key('shop_uv')"
                 :style="m__in_selected_key('shop_uv') ? `border-top: 4px solid ${key_list['shop_uv'].color}` : ''">
              <span style="font-weight: 700">{{ $t('center.visitor') }}</span><br>
              <div style="width: 100%; height: 5px"></div>
              <span style="font-weight: 700; font-size: 23px; margin-top: 10px">
                {{ m__key_metrics_get_value('shop_uv') | currency }}
              </span>
              <strong style="font-size: 18px"></strong><br>
              <div style="width: 100%; height: 5px"></div>
              <template v-if="is_compare_data">
                <strong class="text-danger key_metrics_compare">
                  {{ m__key_metrics_get_value_compare('shop_uv') | currency }}
                </strong>
                <div style="width: 100%; height: 5px"></div>
              </template>
              <el-row>
                <el-col :sm="15">
                  <span
                      style="font-size: 11px !important; line-height: 14px; color: #999;">{{
                      m__get_date_option_compare()
                    }}</span>
                </el-col>
                <el-col :sm="9" class="text-right">
                  <span v-if="m__key_metrics_get_chain_ratio('shop_uv') >= 0"
                        style="font-size: 11px !important; font-weight: 700" class="text-success">
                    +{{ m__key_metrics_get_chain_ratio('shop_uv') }}%
                  </span>
                  <span v-else style="font-size: 11px !important; font-weight: 700" class="text-danger">
                    {{ m__key_metrics_get_chain_ratio('shop_uv') }}%
                  </span>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :sm="4" style="padding: 0 5px">
            <div class="important-box" @click="m__select_key('shop_pv')"
                 :style="m__in_selected_key('shop_pv') ? `border-top: 4px solid ${key_list['shop_pv'].color}` : ''">
              <span style="font-weight: 700">{{ $t('center.page_views') }}</span><br>
              <div style="width: 100%; height: 5px"></div>
              <span style="font-weight: 700; font-size: 23px; margin-top: 10px">
                {{ m__key_metrics_get_value('shop_pv') | currency }}
              </span>
              <strong style="font-size: 18px"></strong><br>
              <div style="width: 100%; height: 5px"></div>
              <template v-if="is_compare_data">
                <strong class="text-danger key_metrics_compare">
                  {{ m__key_metrics_get_value_compare('shop_pv') | currency }}
                </strong>
                <div style="width: 100%; height: 5px"></div>
              </template>
              <el-row>
                <el-col :sm="15">
                  <span
                      style="font-size: 11px !important; line-height: 14px; color: #999;">{{
                      m__get_date_option_compare()
                    }}</span>
                </el-col>
                <el-col :sm="9" class="text-right">
                  <span v-if="m__key_metrics_get_chain_ratio('shop_pv') >= 0"
                        style="font-size: 11px !important; font-weight: 700" class="text-success">
                    +{{ m__key_metrics_get_chain_ratio('shop_pv') }}%
                  </span>
                  <span v-else style="font-size: 11px !important; font-weight: 700" class="text-danger">
                    {{ m__key_metrics_get_chain_ratio('shop_pv') }}%
                  </span>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-if="!total_minimize" style="margin-top: 15px; padding-left: 5px">
        <el-row>
          <el-col :sm="12">
            <p><strong style="font-size: 17px">{{ $t('base.chart') }}</strong></p>
          </el-col>
          <el-col :sm="12" class="text-right" style="padding: 5px 10px 0 0">
            <template v-for="key in Object.keys(key_list)" v-if="m__in_selected_key(key)">
              &nbsp;&nbsp;&nbsp;
              <span class="circle" :style="`background-color: ${key_list[key].color}`"></span>
              <span style="font-size: 14px">{{ key_list[key].name }}</span>
            </template>
          </el-col>
        </el-row>
        <DataCenterLineChart style="height: 260px; width: 100%"
                             :key_metrics="key_metrics"
                             :period="period"
                             :start_time="start_time"
                             :key_list="key_list"
                             :selected_key="selected_key"
                             :selected_key_list="selected_key_list"
                             :order_type="order_type">
        </DataCenterLineChart>
      </div>
    </div>

    <div
        v-loading="loading.get_data"
        style="min-height: 600px; background-color:white; padding:10px 10px 5px 10px; overflow: hidden; margin-top: 10px">
      <el-row>
        <el-col :sm="12" style="padding-left: 5px">
          <strong style="font-size: 15px !important;">{{ $t('base.sales_metrics') }}: </strong>
        </el-col>
      </el-row>

      <div style="margin-top: 20px">
        <strong class="text-primary" style="font-size: 15px">- {{ $t('base.buyer_info') }}</strong>
        <table class="gmv-table" style="margin-top: 10px">
          <tbody>
          <tr>
            <td style="width: 180px !important;"><strong style="font-size: 13px">{{ $t('base.total_buyers') }}</strong>
            </td>
            <td style="width: 180px !important;">
              {{ (new_buyers && existing_buyers ? new_buyers.buyers + existing_buyers.buyers : 0) | currency }}
              <template v-if="is_compare_data">
                <br>
                <strong class="text-danger key_metrics_compare">
                  {{
                    (new_buyers_compare && existing_buyers_compare ? new_buyers_compare.buyers + existing_buyers_compare.buyers : 0) | currency
                  }}
                </strong>
              </template>
            </td>
            <td style="width: 180px !important;">&nbsp;</td>
            <td style="width: 180px !important;">&nbsp;</td>
          </tr>
          <tr>
            <td><strong style="font-size: 13px">{{ $t('base.new_buyers') }}</strong></td>
            <td>
              {{ (new_buyers ? new_buyers.buyers : 0) | currency }} &nbsp;&nbsp;
              <strong class="text-success">{{
                  new_buyers ? (new_buyers.buyers_percentage * 100).toFixed(2) : '0.00'
                }}%
              </strong>
              <template v-if="is_compare_data">
                <br>
                <strong class="text-danger key_metrics_compare">
                  {{ (new_buyers_compare ? new_buyers_compare.buyers : 0) | currency }}
                </strong>
              </template>
            </td>
            <td><strong style="font-size: 13px">{{ $t('base.new_followers') }}</strong></td>
            <td>
              {{ new_followers | currency }}
              <template v-if="is_compare_data">
                <br>
                <strong class="text-danger key_metrics_compare">
                  {{ new_followers_compare | currency }}
                </strong>
              </template>
            </td>
          </tr>
          <tr>
            <td><strong style="font-size: 13px">{{ $t('base.existing_buyers') }}</strong></td>
            <td>
              {{ (existing_buyers ? existing_buyers.buyers : 0) | currency }} &nbsp;&nbsp;
              <strong class="text-danger">{{
                  existing_buyers ? (existing_buyers.buyers_percentage * 100).toFixed(2) : '0.00'
                }}% </strong>
              <template v-if="is_compare_data">
                <br>
                <strong class="text-danger key_metrics_compare">
                  {{ (existing_buyers_compare ? existing_buyers_compare.buyers : 0) | currency }}
                </strong>
              </template>
            </td>
            <td><strong style="font-size: 13px">{{ $t('center.aov') }}</strong></td>
            <td>
              {{
                overview_funnel && overview_funnel.confirmed_sales_per_buyer ? overview_funnel.confirmed_sales_per_buyer.value : 0 | currency
              }}
              <template v-if="is_compare_data">
                <br>
                <strong class="text-danger key_metrics_compare">
                  {{
                    overview_funnel_compare && overview_funnel_compare.confirmed_sales_per_buyer ? overview_funnel_compare.confirmed_sales_per_buyer.value : 0 | currency
                  }}
                </strong>
              </template>
            </td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td><strong style="font-size: 13px">{{ $t('base.funnel_sales') }}</strong></td>
            <td>
              {{
                overview_funnel && overview_funnel.confirmed_sales ? overview_funnel.confirmed_sales.value : 0 | currency
              }}
              <template v-if="is_compare_data">
                <br>
                <strong class="text-danger key_metrics_compare">
                  {{
                    overview_funnel_compare && overview_funnel_compare.confirmed_sales ? overview_funnel_compare.confirmed_sales.value : 0 | currency
                  }}
                </strong>
              </template>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div style="margin-top: 20px">
        <strong class="text-primary" style="font-size: 15px">- {{ $t('center.customer_segment') }}</strong>
        <el-table :data="composition_pricezone">
          <el-table-column :label="$t('center.pricing_segment')">
            <template slot-scope="scope">
              {{ scope.row.price_zone[0] | currency }}
              <template v-if="scope.row.price_zone[1] >= 0"> - {{ scope.row.price_zone[1] | currency }}</template>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.buyers')">
            <template slot-scope="scope">{{ scope.row.buyers | currency }}</template>
          </el-table-column>
          <el-table-column :label="'% ' + $t('base.buyers')">
            <template slot-scope="scope">{{ (scope.row.buyers_percentage * 100).toFixed(2) }}</template>
          </el-table-column>
          <el-table-column :label="$t('base.sales')">
            <template slot-scope="scope">{{ scope.row.sales | currency }}</template>
          </el-table-column>
          <el-table-column :label="$t('metric.conversion_rate')">
            <template slot-scope="scope">{{ (scope.row.conversion_rate * 100).toFixed(2) }}</template>
          </el-table-column>
        </el-table>

        <el-row style="margin-top: 30px">
          <el-col :sm="6">
            <el-button type="info" size="mini" @click="m__select_top_10" :disabled="!shopee_shop.selected">
              <template v-if="list_true.filter(i => i.checked).length === 10">{{ $t('base.unselect') }}</template>
              <template v-else>{{
                  $t('base.select_top_x_y', {
                    x: '10',
                    y: $t('base.products')
                  })
                }}
              </template>
            </el-button>
          </el-col>
          <el-col :sm="18" class="text-right">
            <el-button size="mini" icon="el-icon-download" :disabled="!shopee_shop.selected || loading.get_data"
                       @click="m__export_product_data">
              {{ $t('base.export_data') }}
            </el-button>
            <el-button type="primary" size="mini" :disabled="!shopee_shop.selected"
                       @click="m__redirect_page('flash-sale', 'Flash sale')">
              {{ $t('ads.create_shop_flash_sale') }}
            </el-button>
            <el-button type="primary" size="mini" :disabled="!shopee_shop.selected"
                       @click="m__redirect_page('voucher', $t('menu.shop_vouchers'))">
              {{ $t('ads.create_shop_vouchers') }}
            </el-button>
            <el-button type="primary" size="mini" @click=" m__redirect_page('marketing/pas', $t('base.campaign'))">
              {{ $t('base.create_new_campaign') }}
            </el-button>
            &nbsp;&nbsp;
            <el-input size="mini" style="width: 160px" suffix-icon="el-icon-search" v-model="filter.keyword"
                      :placeholder="$t('input.placeholder')" :disabled="!shopee_shop.selected"></el-input>
          </el-col>
        </el-row>
        <el-table ref="productPerformance" style="margin-top: 10px" :data="list_display" @sort-change="m__sort_change">
          <el-table-column label="#" width="40px" fixed="left">
            <template slot="header" slot-scope="scope">
              <el-checkbox
                  :value="list_display.length && list_display.filter(i => i.checked).length === list_display.length"
                  size="mini" @change="(e) => {list_display.forEach(i => i.checked = e)}"></el-checkbox>
            </template>
            <template slot-scope="scope">
              <el-checkbox size="mini" v-model="scope.row.checked"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column width="45px" fixed="left">
            <template slot-scope="scope">
              <img :src="SHOPEE_IMAGE(scope.row.image)" alt="logo"
                   style="width:35px; height: 35px;">
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.product')" min-width="350px" show-tooltip-when-overflow fixed="left"
                           prop="name">
            <template slot-scope="scope">
              <a href="javascript:void(0)"
                 @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${scope.row.id}`, shop)">
                {{ scope.row.name }}
              </a>
              <br>
              ID: {{ scope.row.id }}
            </template>
          </el-table-column>
          <el-table-column v-if="allow_get_stock" :label="$t('product.stock')" prop="stock" sortable="custom"
                           width="140px">
            <template slot-scope="scope">
              {{ scope.row.stock | currency }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('metric.product_impressions')" prop="pv" sortable="custom" width="140px">
            <template slot-scope="scope">
              {{ scope.row.pv | currency }}
              <div v-if="is_compare_data && scope.row.compare" style="font-size: 12px" class="text-danger">
                {{ scope.row.compare.pv | currency }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('metric.users_views')" prop="pv" sortable="custom" width="140px">
            <template slot-scope="scope">
              {{ scope.row.uv | currency }}
              <div v-if="is_compare_data && scope.row.compare" style="font-size: 12px" class="text-danger">
                {{ scope.row.compare.uv | currency }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('metric.add_to_cart_units')" prop="add_to_cart_units" sortable="custom"
                           width="160px">
            <template slot-scope="scope">
              {{ scope.row.add_to_cart_units | currency }}
              <div v-if="is_compare_data && scope.row.compare" style="font-size: 12px" class="text-danger">
                {{ scope.row.compare.add_to_cart_units | currency }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('center.add_to_cart_rate_on_view')" prop="pv_to_add_to_cart_rate"
                           sortable="custom" width="160px">
            <template slot-scope="scope">
              {{ scope.row.pv_to_add_to_cart_rate }}%
              <div v-if="is_compare_data && scope.row.compare" style="font-size: 12px" class="text-danger">
                {{ scope.row.compare.pv_to_add_to_cart_rate }}%
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('center.add_to_cart_rate_on_user_view')" prop="uv_to_add_to_cart_rate"
                           sortable="custom" width="160px">
            <template slot-scope="scope">
              {{ scope.row.uv_to_add_to_cart_rate }}%
              <div v-if="is_compare_data && scope.row.compare" style="font-size: 12px" class="text-danger">
                {{ scope.row.compare.uv_to_add_to_cart_rate }}%
              </div>
            </template>
          </el-table-column>
          <template v-if="order_type === ''">
            <el-table-column :label="$t('center.placed_units_all')" prop="placed_units" sortable="custom" width="160px">
              <template slot-scope="scope">
                {{ scope.row.compare }}
                <div v-if="is_compare_data && scope.row.compare" style="font-size: 12px" class="text-danger">
                  {{ scope.row.compare.placed_units | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('center.placed_units_on_add_to_cart_units_rate')"
                             prop="add_to_cart_to_placed_units_rate" sortable="custom" width="160px">
              <template slot-scope="scope">
                {{ scope.row.add_to_cart_to_placed_units_rate }}%
                <div v-if="is_compare_data && scope.row.compare" style="font-size: 12px" class="text-danger">
                  {{ scope.row.compare.add_to_cart_to_placed_units_rate }}%
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('center.sales_all')" prop="placed_sales" sortable="custom" width="160px">
              <template slot-scope="scope">
                {{ m__calculate(scope.row.placed_sales) | currency }}
                <div v-if="is_compare_data && scope.row.compare" style="font-size: 12px" class="text-danger">
                  {{ m__calculate(scope.row.compare.placed_sales) | currency }}
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-if="order_type === 'confirmed'">
            <el-table-column :label="$t('center.placed_units_confirmed')" prop="confirmed_units" sortable="custom"
                             width="160px">
              <template slot-scope="scope">
                {{ scope.row.confirmed_units | currency }}
                <div v-if="is_compare_data && scope.row.compare" style="font-size: 12px" class="text-danger">
                  {{ scope.row.compare.confirmed_units | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('center.placed_units_on_add_to_cart_units_rate')"
                             prop="add_to_cart_to_confirmed_units_rate"
                             sortable="custom" width="160px">
              <template slot-scope="scope">
                {{ scope.row.add_to_cart_to_confirmed_units_rate }}%
                <div v-if="is_compare_data && scope.row.compare" style="font-size: 12px" class="text-danger">
                  {{ scope.row.compare.add_to_cart_to_confirmed_units_rate }}%
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('center.sales_confirmed')" prop="confirmed_sales" sortable="custom"
                             width="160px">
              <template slot-scope="scope">
                {{ m__calculate(scope.row.confirmed_sales) | currency }}
                <div v-if="is_compare_data && scope.row.compare" style="font-size: 12px" class="text-danger">
                  {{ m__calculate(scope.row.compare.confirmed_sales) | currency }}
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-if="order_type === 'paid'">
            <el-table-column :label="$t('center.placed_units_paid')" prop="paid_units" sortable="custom" width="160px">
              <template slot-scope="scope">
                {{ scope.row.paid_units | currency }}
                <div v-if="is_compare_data && scope.row.compare" style="font-size: 12px" class="text-danger">
                  {{ scope.row.compare.paid_units | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('center.placed_units_on_add_to_cart_units_rate')"
                             prop="add_to_cart_to_paid_units_rate"
                             sortable="custom" width="160px">
              <template slot-scope="scope">
                {{ scope.row.add_to_cart_to_paid_units_rate }}%
                <div v-if="is_compare_data && scope.row.compare" style="font-size: 12px" class="text-danger">
                  {{ scope.row.compare.add_to_cart_to_paid_units_rate }}%
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('center.sales_paid')" prop="paid_sales" sortable="custom" width="160px">
              <template slot-scope="scope">
                {{ m__calculate(scope.row.paid_sales) | currency }}
                <div v-if="is_compare_data && scope.row.compare" style="font-size: 12px" class="text-danger">
                  {{ m__calculate(scope.row.compare.paid_sales) | currency }}
                </div>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <el-pagination :current-page.sync="filter.current_page" :page-size="filter.page_size"
                       layout="total, prev, pager, next" :total="list_true.length"></el-pagination>
      </div>
    </div>

    <el-dialog :visible.sync="compare_data_dialog" :close-on-click-modal="false" width="600px">
      <div slot="title" style="padding:10px">
        <strong style="font-size:14px">{{ $t('base.compare_data') }}</strong>

        <br>
        <br>
        <div style="line-height: 20px">
          <strong style="font-size:13px"> {{ $t('select.compare_duration') }}:</strong>
          <br>
          <el-select v-model="date_option_compare" value="" size="small"
                     :disabled="!shopee_shop.selected || loading.get_data" @change="m__change_compare_date">
            <el-option v-for="item in date_options.filter(i => i.period !== 'year')" :key="item.period"
                       :value="item.period" :label="item.label"></el-option>
          </el-select> &nbsp;&nbsp;
          <el-date-picker
              id="date-picker-data-center-compare"
              v-model="date_compare"
              :type="m__date_option_compare().date_type"
              :format="m__date_option_compare().format"
              :picker-options="{firstDayOfWeek: 1, disabledDate(time) {return time.getTime() > Date.now()}}"
              :placeholder="$t('input.select_time')"
              :start-placeholder="$t('input.start_time')"
              end-:placeholder="$t('base.select_end_time')"
              size="small"
              :disabled="!shopee_shop.selected || !m__date_option_compare().show_date || loading.get_data">
          </el-date-picker>
        </div>

        <div style="margin-top: 30px" class="text-right">
          <el-button size="mini" type="danger"
                     @click="is_compare_data = false; is_compare_campaign = false; compare_data_dialog = false">
            {{ $t('base.disable_compare_data') }}
          </el-button>
          <el-button size="mini" type="primary" icon="el-icon-check"
                     :loading="loading.compare_data" @click="m__confirm_compare_data">
            {{ $t('base.execute') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DataCenterLineChart from './line_chartjs'
import ComponentMetric from '../pas/component/component_metric.vue'
import { check_feature, show_expr_notification } from '../../addon/check_license'
import {
  drop as _drop,
  filter as _filter,
  orderBy as _orderBy,
  take as _take,
  uniqBy as _uniqBy,
  pick as _pick
} from 'lodash'
import { date_option_fixed_list, agency_plan_fixed_list } from '../../addon/fixed_list'
import { map_graph_by_time_response, map_graph_response } from '../../addon/ads_function'
import { get_shop_mixins } from "../../mixins/get_shop";
import { fix_ads_mixins } from "../../mixins/fix_ads";

export default {
  name: 'page__data_center',

  mixins: [get_shop_mixins, fix_ads_mixins],

  components: {
    DataCenterLineChart,
    ComponentMetric
  },

  data() {
    return {
      sort_option: {
        order: null,
        prop: null
      },
      filter: {
        page_size: 10,
        current_page: 0,
        keyword: '',
        pages: [10, 20, 30, 40, 50, 100]
      },
      loading: {
        get_data: false,
        marketing_report_file: false,
        compare_data: false,
        export_report: false
      },
      seller: null,
      shop: {},
      date: '',
      order_type: 'confirmed',
      date_option: 'real_time',
      date_options: [
        {
          label: this.$t('center.today_until_x', { x: this.dayjs().hour() }),
          period: 'real_time',
          show_date: false,
          date_type: 'date',
          format: 'dd-MM-yyyy',
          compare: this.$t('center.vs_x_yesterday', { x: `00:00-${this.dayjs().hour()}:00` })
        },
        {
          label: this.$t('base.yesterday'),
          period: 'yesterday',
          show_date: false,
          date_type: 'date',
          format: 'dd-MM-yyyy',
          compare: this.$t('center.vs_previous_day')
        },
        {
          label: this.$t('center.past7days'),
          period: 'past7days',
          show_date: false,
          date_type: 'date',
          format: 'dd-MM-yyyy',
          compare: this.$t('center.vs_7_days')
        },
        {
          label: this.$t('center.past3days'),
          period: 'past30days',
          show_date: false,
          date_type: 'date',
          format: 'dd-MM-yyyy',
          compare: this.$t('center.vs_30_days')
        },
        {
          label: this.$t('center.by_day'),
          period: 'day',
          show_date: true,
          date_type: 'date',
          format: 'dd-MM-yyyy',
          compare: this.$t('center.vs_previous_day')
        },
        {
          label: this.$t('center.by_week'),
          period: 'week',
          show_date: true,
          date_type: 'week',
          format: 'Tuần WW',
          compare: this.$t('center.vs_previous_week')
        },
        {
          label: this.$t('center.by_month'),
          period: 'month',
          show_date: true,
          date_type: 'month',
          format: '',
          compare: this.$t('center.vs_previous_month')
        },
        {
          label: this.$t('center.by_year'),
          period: 'year',
          show_date: true,
          date_type: 'year',
          format: '',
          compare: this.$t('center.vs_previous_year')
        }
      ],
      key_metrics: {},
      key_metrics_compare: {},
      period: '',
      start_time: null,
      end_time: null,
      ads_start_time: null,
      ads_end_time: null,
      selected_key: 'real_time',
      selected_key_list: ['place_gmv', 'shop_uv'],
      key_list: {
        place_gmv: {
          name: this.$t('center.sales'),
          color: 'rgb(54, 127, 227)'
        },
        place_orders: {
          name: this.$t('center.orders'),
          color: 'rgb(246, 189, 22)'
        },
        shop_uv_to_placed_buyers_rate: {
          name: this.$t('center.conversions_rate'),
          color: 'rgb(35, 170, 171)'
        },
        place_sales_per_order: {
          name: this.$t('center.sales_on_orders'),
          color: 'rgb(88, 183, 241)'
        },
        shop_uv: {
          name: this.$t('center.visitor'),
          color: 'rgb(251, 115, 75)'
        },
        shop_pv: {
          name: this.$t('center.page_views'),
          color: 'rgb(148, 95, 185)'
        }
      },
      selected_tab: 'all',
      total_metrics: {},
      total_reports: [],
      search_ads_metrics: {},
      search_ads_reports: [],
      targeting_ads_metrics: {},
      targeting_ads_reports: [],
      boost_ads_metrics: {},
      boost_ads_reports: [],
      total_cps: 0,
      total_cir: 0,

      is_compare_campaign: true,
      new_cpc_homepage_metrics: {},
      new_cpc_homepage_metrics_compare: {},
      new_cpc_homepage_reports: [],
      product_homepage_metrics: {},
      product_homepage_metrics_compare: {},
      product_homepage_reports: [],
      shop_homepage_metrics: {},
      shop_homepage_metrics_compare: {},
      shop_homepage_reports: [],

      ads_minimize: false,
      total_minimize: false,

      new_buyers: {},
      existing_buyers: {},
      new_buyers_compare: {},
      existing_buyers_compare: {},
      composition_buyers: [],
      composition_pricezone: [],
      overview_funnel: {
        confirmed_sales_per_buyer: {},
        confirmed_sales: {}
      },
      overview_funnel_compare: {
        confirmed_sales_per_buyer: {},
        confirmed_sales: {}
      },
      metrics_customer: {},
      metrics_customer_compare: {},
      new_followers: 0,
      new_followers_compare: 0,
      product_performance: [],

      interval: null,
      agency_plan_fixed_list: agency_plan_fixed_list,

      is_compare_data: false,
      compare_data_dialog: false,

      expected_cir: null,

      date_option_compare: 'past30days',
      date_compare: '',
      period_compare: '',

      ads_version: 'new',

      product_performance_compare: [],

      product_detail_cache: {},

      allow_get_stock: true
    }
  },

  beforeRouteEnter(to, from, next) {
    if (check_feature('data_center')) {
      next()
    } else {
      show_expr_notification()
      next('/')
    }
  },

  async beforeMount() {
    this.date_option = date_option_fixed_list.some(i => this.$store.state.userInfo.username.includes(i)) ? 'past7days' : 'real_time'

    await this.m__get_shopee_shop()
    this.m__generate_scroll()
  },

  beforeDestroy() {
    clearInterval(this.interval)
    const dashboard_wrapper = document.getElementById('dashboard-wrapper')
    dashboard_wrapper.onscroll = () => {
    }
  },

  computed: {
    list_true() {
      let result = this.product_performance

      if (this.sort_option.order) {
        this.sort_option.order === 'ascending' && (result = _orderBy(result, [this.sort_option.prop], ['asc']))
        this.sort_option.order === 'descending' && (result = _orderBy(result, [this.sort_option.prop], ['desc']))
      }

      const words = this.remove_unicode(this.filter.keyword)
      return _filter(result, item => this.remove_unicode(`${item.id} ${item.name.normalize()}`).includes(words))
    },

    list_display() {
      const limit = this.filter.page_size
      const skip = limit * (this.filter.current_page - 1)

      return _take(_drop(this.list_true, skip), limit)
    }
  },

  watch: {
    'shopee_shop.selected': function () {
      this.m__initial_view()
    },

    // 'selected_tab': function () {
    //   if (this.selected_tab === '') {
    //     if (!Object.keys(this.new_cpc_homepage_metrics).length) {
    //
    //     }
    //   }
    // }
  },

  methods: {
    async m__export_product_data() {
      if (!this.product_performance.length) {
        return
      }

      const data = []
      const cols = [this.$t('product.id')]
      for (let i = 2; i < this.$refs.productPerformance.columns.length; i++) {
        cols.push(this.$refs.productPerformance.columns[i].label)
      }
      data.push(cols)

      for (const item of this.product_performance) {
        const row = [item.id]
        for (let i = 2; i < this.$refs.productPerformance.columns.length; i++) {
          row.push(item[this.$refs.productPerformance.columns[i].property])
        }
        data.push(row)
      }

      const filename = `products_report_${this.shop.username}_${this.dayjs().format('DDMMYYYY')}.xlsx`
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/export_excel', {
        filename,
        data: data
      }, {
        ...this.cf(),
        responseType: 'blob'
      })
      const url = window.URL.createObjectURL(new Blob([response.body]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    },

    async m__confirm_compare_data() {
      this.loading.compare_data = true

      let date_option = this.date_options.find(i => i.period === this.date_option_compare)
      let start_time = null, end_time = null, period = date_option.period
      this.period_compare = period

      if (date_option.period === 'real_time') {
        start_time = this.dayjs().startOf('d').unix()
        end_time = this.dayjs().startOf('h').unix()
      } else if (date_option.period === 'yesterday') {
        start_time = this.dayjs().subtract(1, 'd').startOf('d').unix()
        end_time = this.dayjs().subtract(1, 'd').endOf('d').unix()
      } else if (date_option.period === 'past7days') {
        start_time = this.dayjs().subtract(7, 'd').startOf('d').unix()
        end_time = this.dayjs().startOf('d').unix()
      } else if (date_option.period === 'past30days') {
        start_time = this.dayjs().subtract(30, 'd').startOf('d').unix()
        end_time = this.dayjs().startOf('d').unix()
      } else {
        if (!this.date_compare) {
          const date_picker = document.getElementById('date-picker-data-center-compare')
          if (date_picker) {
            this.$nextTick(() => {
              date_picker.focus()
            })
          } else {
            this.ntf_w(this.$t('required.select_duration'))
          }
          this.loading.compare_data = false
          return
        }

        if (date_option.period === 'day') {
          start_time = this.dayjs(new Date(this.date_compare)).startOf('d').unix()
          end_time = this.dayjs(new Date(this.date_compare)).add(1, 'd').startOf('d').unix()
        }
        if (date_option.period === 'week') {
          start_time = this.dayjs(new Date(this.date_compare)).startOf('w').add(1, 'd').unix()
          end_time = this.dayjs(new Date(this.date_compare)).endOf('w').add(2, 'd').startOf('d').unix()
          if (this.dayjs(end_time * 1000).isAfter(this.dayjs(), 's')) {
            end_time = this.dayjs().startOf('d').unix()
          }
        }
        if (date_option.period === 'month') {
          start_time = this.dayjs(new Date(this.date_compare)).startOf('M').unix()
          if (new Date().getMonth() === new Date(this.date_compare).getMonth()) {
            end_time = this.dayjs().startOf('d').unix()
          } else {
            end_time = this.dayjs(new Date(this.date_compare)).endOf('M').add(1, 'd').startOf('d').unix()
          }
        }
        if (date_option.period === 'year') {
          start_time = this.dayjs(new Date(this.date_compare)).startOf('y').unix()
          end_time = this.dayjs(new Date(this.date_compare)).startOf('y').unix()
        }
      }

      this.product_performance_compare = []
      let page = 1, page_size = 20
      let product_performance_resp = await this.seller.get_product_performance_main(page, page_size, start_time, end_time, period)

      while (product_performance_resp && product_performance_resp.data && product_performance_resp.data.result &&
      product_performance_resp.data.result.items && product_performance_resp.data.result.items.length) {
        if (this.product_performance_compare.length > product_performance_resp.data.result.total) {
          return
        }

        for (const item of product_performance_resp.data.result.items) {
          item.pv_to_add_to_cart_rate = +item.pv ? parseFloat((item.add_to_cart_units / item.pv * 100).toFixed(2)) : 0
          item.uv_to_add_to_cart_rate = +item.pv ? parseFloat((item.add_to_cart_units / item.uv * 100).toFixed(2)) : 0
          item.add_to_cart_to_placed_units_rate = +item.add_to_cart_units ? parseFloat((item.placed_units / item.add_to_cart_units * 100).toFixed(2)) : 0
          item.add_to_cart_to_paid_units_rate = +item.add_to_cart_units ? parseFloat((item.paid_units / item.add_to_cart_units * 100).toFixed(2)) : 0
          item.add_to_cart_to_confirmed_units_rate = +item.add_to_cart_units ? parseFloat((item.confirmed_units / item.add_to_cart_units * 100).toFixed(2)) : 0
          item.checked = false
        }
        this.product_performance_compare.push(...product_performance_resp.data.result.items)
        page++
        product_performance_resp = await this.seller.get_product_performance_main(page, page_size, start_time, end_time, period)
      }

      this.product_performance_compare = _uniqBy(this.product_performance_compare, 'id')
      // console.log(this.product_performance_compare)

      for (const item of this.product_performance_compare) {
        const found = this.product_performance.find(i => i.id === item.id)
        if (found) {
          found.compare = _pick(item, ['pv', 'uv', 'add_to_cart_units', 'placed_units', 'placed_sales', 'confirmed_units', 'confirmed_sales', 'paid_units', 'paid_sales', 'pv_to_add_to_cart_rate', 'uv_to_add_to_cart_rate', 'add_to_cart_to_placed_units_rate', 'add_to_cart_to_paid_units_rate', 'add_to_cart_to_confirmed_units_rate'])
        }
      }
      this.product_performance = this.clone(this.product_performance)

      await this.m__get_dashboard__key_metrics_compare(start_time, end_time, period)
      await Promise.all([
        this.m__get_metrics_customer_compare(start_time, end_time, period),
        this.get_traffic_overview_compare(start_time, end_time, period),
        this.get_overview_funnel_compare(start_time, end_time, period),
      ])

      // todo: compare ads
      end_time -= 1
      await this.m__get_ads_metrics_compare(start_time * 1000, end_time * 1000)

      this.is_compare_campaign = true
      this.is_compare_data = true
      this.compare_data_dialog = false
      this.loading.compare_data = false
    },

    m__date_option_compare() {
      return this.date_options.find(i => i.period === this.date_option_compare)
    },

    m__change_compare_date() {
      const date_picker = document.getElementById('date-picker-data-center-compare')
      if (date_picker) {
        this.$nextTick(() => {
          date_picker.focus()
        })
      }
    },

    m__show_compare_data() {
      this.compare_data_dialog = true
    },

    m__generate_scroll() {
      this.$nextTick(() => {
        const dashboard_wrapper = document.getElementById('dashboard-wrapper')
        const fixed_select = document.getElementById('fixed-select')
        const select_block = document.getElementById('select-block')
        const first_block = document.getElementById('first-block')

        const select_block_rect = select_block.getBoundingClientRect()
        fixed_select.style.width = select_block_rect.width + 'px'
        this.interval = setInterval(() => {
          const select_block = document.getElementById('select-block')
          const select_block_rect = select_block.getBoundingClientRect()
          fixed_select.style.width = select_block_rect.width + 'px'
        }, 1000)

        const bounding_main_pagination = () => {
          const rect = first_block.getBoundingClientRect()
          const elem_top = rect.top
          if (elem_top > 0) {
            fixed_select.style.zIndex = '-1'
          } else {
            fixed_select.style.zIndex = '2000'
          }
        }
        bounding_main_pagination()

        dashboard_wrapper.onscroll = () => {
          bounding_main_pagination()
        }
      })
    },

    m__redirect_page(path, message) {
      if (this.list_true.filter(i => i.checked).length) {
        const routeData = this.$router.resolve({
          path: path,
          query: {
            shop_id: this.shop.shop_id,
            product_ids: this.list_true.filter(i => i.checked).map(i => i.id).join(',')
          }
        })
        window.open(routeData.href, '_blank').focus()
      } else {
        this.ntf_w(this.$t('required.select_products_to_create') + ' ' + message)
      }
    },

    m__select_top_10() {
      if (this.list_true.filter(i => i.checked).length === 10) {
        this.list_true.forEach(i => i.checked = false)
      } else {
        for (let i = 0; i < 10; i++) {
          if (this.list_true[i]) this.list_true[i].checked = true
        }
      }
    },

    m__sort_change({
                     prop,
                     order
                   }) {
      this.sort_option.order = order
      this.sort_option.prop = prop
    },

    m__date_option() {
      return this.date_options.find(i => i.period === this.date_option)
    },

    async m__initial_view() {
      const items = this.shopee_shop.list.filter(e => e._id === this.shopee_shop.selected)

      try {
        if (this.shopee_shop.selected.length > 6) {
          if (items.length > 0) {
            const shop = items[0]

            // todo: check role
            if (!this.check_role(shop, 'marketing', 'get_metrics')) {
              this.shopee_shop.selected = ''
              return
            }

            this.shop = shop
            this.seller = await this.init_seller(shop)

            if (!await this.check_shop(this.seller)) {
              this.shopee_shop.selected = ''
              return
            }

            const ads_data_response = await this.seller.marketing_pas_get_ads_data()
            if (ads_data_response.data && ads_data_response.data.setup_flow_version) {
              this.ads_version = ads_data_response.data.setup_flow_version.version
              this.selected_tab = this.ads_version === 'new' ? 'new_cpc_homepage' : 'all'
            }

            await this.m__update_data()
            this.ntf_s(`${this.$t('shop.connected_to')}: ${this.shop.username}`)
          }
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(`${this.$t('shop.connect_shop_error')}: ${this.shop.username}`)
      } finally {
        // this.loading.get_flash_sale = false
      }
    },

    async m__update_data() {
      this.loading.get_data = true

      let date_option = this.date_options.find(i => i.period === this.date_option)
      let start_time = null, end_time = null, period = date_option.period
      this.period = period

      if (date_option.period === 'real_time') {
        start_time = this.dayjs().startOf('d').unix()
        end_time = this.dayjs().startOf('h').unix()
      } else if (date_option.period === 'yesterday') {
        start_time = this.dayjs().subtract(1, 'd').startOf('d').unix()
        end_time = this.dayjs().subtract(1, 'd').endOf('d').unix()
      } else if (date_option.period === 'past7days') {
        start_time = this.dayjs().subtract(7, 'd').startOf('d').unix()
        end_time = this.dayjs().startOf('d').unix()
      } else if (date_option.period === 'past30days') {
        start_time = this.dayjs().subtract(30, 'd').startOf('d').unix()
        end_time = this.dayjs().startOf('d').unix()
      } else {
        if (!this.date) {
          this.ads_start_time = this.start_time = null
          this.ads_end_time = this.end_time = null

          const date_picker = document.getElementById('date-picker-data-center')
          if (date_picker) {
            this.$nextTick(() => {
              date_picker.focus()
            })
          } else {
            this.ntf_w(this.$t('required.select_duration'))
          }
          this.loading.get_data = false
          return
        }

        if (date_option.period === 'day') {
          start_time = this.dayjs(new Date(this.date)).startOf('d').unix()
          end_time = this.dayjs(new Date(this.date)).add(1, 'd').startOf('d').unix()
        }
        if (date_option.period === 'week') {
          start_time = this.dayjs(new Date(this.date)).startOf('w').add(1, 'd').unix()
          end_time = this.dayjs(new Date(this.date)).endOf('w').add(2, 'd').startOf('d').unix()
          if (this.dayjs(end_time * 1000).isAfter(this.dayjs(), 's')) {
            end_time = this.dayjs().startOf('d').unix()
          }
        }
        if (date_option.period === 'month') {
          start_time = this.dayjs(new Date(this.date)).startOf('M').unix()
          if (new Date().getMonth() === new Date(this.date).getMonth()) {
            end_time = this.dayjs().startOf('d').unix()
          } else {
            end_time = this.dayjs(new Date(this.date)).endOf('M').add(1, 'd').startOf('d').unix()
          }
        }
        if (date_option.period === 'year') {
          start_time = this.dayjs(new Date(this.date)).startOf('y').unix()
          end_time = this.dayjs(new Date(this.date)).startOf('y').unix()
          // end_time = this.dayjs(new Date(this.date)).endOf('y').add(1, 'd').startOf('d').unix()
        }
      }

      try {
        this.ads_start_time = this.start_time = start_time
        this.ads_end_time = this.end_time = end_time

        await Promise.all([
          this.m__get_dashboard__key_metrics(start_time, end_time, period)
        ])

        Promise.all([
          this.m__get_composition_buyers(start_time, end_time, period, this.order_type || 'placed'),
          this.m__get_composition_pricezone(start_time, end_time, period, this.order_type || 'placed'),
          this.get_overview_funnel(start_time, end_time, period),
          this.get_traffic_overview(start_time, end_time, period),
          // this.m__get_metrics_customer(start_time, end_time, period, this.order_type)
        ]).catch(console.error)

        this.m__get_product_performance(start_time, end_time, period).then(null)

        if (period === 'past7days') {
          this.ads_start_time = this.dayjs().subtract(1, 'week').add(1, 'day').startOf('d').unix()
          this.ads_end_time = this.dayjs().endOf('day').unix()
        }
        if (period === 'past30days') {
          this.ads_start_time = this.dayjs().subtract(1, 'month').add(1, 'day').startOf('d').unix()
          this.ads_end_time = this.dayjs().endOf('day').unix()
        }

        if (period === 'year') {
          await this.m__get_ads_metrics_by_year(this.dayjs(this.date).year())
        } else {
          await this.m__get_ads_metrics(new Date(this.ads_start_time * 1000), new Date(this.ads_end_time * 1000 - 1000))
        }

        if (this.m__key_metrics_get_value('place_orders')) {
          this.total_cps = (this.ads_version === 'new' ? this.new_cpc_homepage_metrics.cost : this.total_metrics.cost) / this.m__key_metrics_get_value('place_orders')
        }
        if (this.m__key_metrics_get_value('place_gmv')) {
          this.total_cir = (this.ads_version === 'new' ? this.new_cpc_homepage_metrics.cost : this.total_metrics.cost) / this.m__key_metrics_get_value('place_gmv') * 100
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.get_data = false
      }
    },

    async m__get_dashboard__key_metrics(start_time, end_time, period) {
      const resp = await this.seller.dashboard__key_metrics(start_time, end_time, period)
      this.key_metrics = resp.result || {}
    },

    async m__get_dashboard__key_metrics_compare(start_time, end_time, period) {
      const resp = await this.seller.dashboard__key_metrics(start_time, end_time, period)
      this.key_metrics_compare = resp.result || {}
    },

    m__key_metrics_get_value(key) {
      if (this.order_type !== '') {
        key = key.replace(/(placed|place)/, this.order_type)
      }

      return this.key_metrics && this.key_metrics[key] ? this.key_metrics[key].value : 0
    },

    m__key_metrics_get_value_compare(key) {
      if (this.order_type !== '') {
        key = key.replace(/(placed|place)/, this.order_type)
      }

      return this.key_metrics_compare && this.key_metrics_compare[key] ? this.key_metrics_compare[key].value : 0
    },

    m__key_metrics_get_chain_ratio(key) {
      if (this.order_type !== '') {
        key = key.replace(/(placed|place)/, this.order_type)
      }

      if (this.key_metrics && this.key_metrics[key] && this.key_metrics[key].chain_ratio === -1000000) {
        return 0
      }

      return this.key_metrics && this.key_metrics[key] ? +(this.key_metrics[key].chain_ratio * 100).toFixed(2) : '0'
    },

    m__get_date_option_compare() {
      const date_option = this.date_options.find(i => i.period === this.date_option)
      if (date_option) {
        return date_option.compare
      } else {
        return ''
      }
    },

    m__select_key(key) {
      const set_key = new Set(this.selected_key_list)
      if (set_key.size === 1 && set_key.has(key)) {
        return
      }
      if (set_key.has(key)) {
        set_key.delete(key)
      } else {
        if (set_key.size < 4) set_key.add(key)
      }
      this.selected_key_list = [...set_key]
    },

    m__in_selected_key(key) {
      return this.selected_key_list.includes(key)
    },

    m__clear_metrics() {
      this.new_cpc_homepage_metrics = {}
      this.new_cpc_homepage_reports = []
      this.product_homepage_metrics = {}
      this.product_homepage_reports = []
      this.shop_homepage_metrics = {}
      this.shop_homepage_reports = []
      this.total_metrics = {}
      this.total_reports = []
      this.search_ads_metrics = {}
      this.search_ads_reports = []
      this.targeting_ads_metrics = {}
      this.targeting_ads_reports = []
    },

    async m__get_ads_metrics_by_year(year) {
      this.m__clear_metrics()

      if (this.ads_version === 'old') {
        const types = ['homepage_report', 'search_report', 'discovery_report', 'boost_report']
        const total_metrics_type = {}

        const end_month = year < this.dayjs().year() ? 11 : this.dayjs().month()
        for (let i = 0; i <= end_month; i++) {
          const start_time = this.dayjs([year, i]).startOf('month').toDate()
          const end_time = this.dayjs([year, i]).endOf('month').toDate()

          await this.sleep(1000)
          const resp = await this.seller.marketing_homepage_report_by_time(start_time, end_time, '[0,1,2,3,4,5,8]')
          if (!resp || !resp.data || !resp.data.data) {
            continue
          }

          for (const type of types) {
            if (!total_metrics_type[type]) total_metrics_type[type] = {}

            for (const item of resp.data.data[type]) {
              for (const key of Object.keys(item)) {
                if (total_metrics_type[type][key]) {
                  total_metrics_type[type][key] += +item[key]
                } else {
                  total_metrics_type[type][key] = +item[key]
                }
              }
            }
          }
        }

        for (const type of types) {
          const metrics = total_metrics_type[type]

          metrics.ctr = +metrics.impression ? +(metrics.click / metrics.impression * 100).toFixed(2) : 0
          metrics.broad_cir = +metrics.broad_gmv ? +(+metrics.cost / +metrics.broad_gmv * 100).toFixed(2) : 0
          metrics.broad_roi = +metrics.cost ? +(+metrics.broad_gmv / +metrics.cost).toFixed(2) : 0
          metrics.atosa_cpc = +metrics.click ? this.m__calculate(+metrics.cost / +metrics.click) : 0
          if (type === 'homepage_report') {
            this.total_metrics = metrics
          }
          if (type === 'search_report') {
            this.search_ads_metrics = metrics
          }
          if (type === 'discovery_report') {
            this.targeting_ads_metrics = metrics
          }
          if (type === 'boost_adsboost_report') {
            this.boost_ads_metrics = metrics
          }
        }
      }

      if (this.ads_version === 'new') {
        const keys = ['new_cpc_homepage', 'product_homepage', 'shop_homepage']
        const total_metrics_type = {}

        const end_month = year < this.dayjs().year() ? 11 : this.dayjs().month()
        for (let i = 0; i <= end_month; i++) {
          const start_time = this.dayjs([year, i]).startOf('month').toDate()
          const end_time = this.dayjs([year, i]).endOf('month').toDate()

          for (const key of keys) {
            if (!total_metrics_type[key]) total_metrics_type[key] = {}

            const report_response = await this.seller.marketing_get_time_graph(key, this.dayjs(start_time).startOf('day').unix(), this.dayjs(end_time).endOf('day').unix(), {})
            if (report_response.data) {
              const metrics = map_graph_response(report_response.data.report_aggregate)
              for (const key_metric of Object.keys(metrics)) {
                if (total_metrics_type[key][key_metric]) {
                  total_metrics_type[key][key_metric] += +metrics[key_metric]
                } else {
                  total_metrics_type[key][key_metric] = +metrics[key_metric]
                }
              }
            }
          }
        }

        for (const key of keys) {
          const metrics = total_metrics_type[key]

          metrics.ctr = +metrics.impression ? +(+metrics.click / +metrics.impression * 100).toFixed(2) : 0
          metrics.broad_cir = +metrics.broad_gmv ? +(+metrics.cost / +metrics.broad_gmv * 100).toFixed(2) : 0
          metrics.broad_roi = +metrics.cost ? +(+metrics.broad_gmv / +metrics.cost).toFixed(2) : 0
          metrics.atosa_cpc = +metrics.click ? this.m__calculate(+metrics.cost / +metrics.click) : 0

          this[key + '_metrics'] = metrics
        }
      }

      this.ntf_w(this.$t('center.cannot_show_chart'))
    },

    async m__get_ads_metrics(start_time, end_time) {
      this.m__clear_metrics()

      if (this.ads_version === 'old') {
        const types = ['homepage_report', 'search_report', 'discovery_report', 'boost_report']

        await this.sleep(1000)
        const resp = await this.seller.marketing_homepage_report_by_time(start_time, end_time, '[0,1,2,3,4,5,8]')
        if (!resp || !resp.data || !resp.data.data) {
          this.m__clear_metrics()
          this.ntf_w(this.$t('ads.error_with_exporting'))
          return
        }

        for (const type of types) {
          const metrics = {}
          for (const item of resp.data.data[type]) {
            for (const key of Object.keys(item)) {
              if (metrics[key]) {
                metrics[key] += +item[key]
              } else {
                metrics[key] = +item[key]
              }
            }
          }

          metrics.ctr = +(metrics.click / metrics.impression * 100).toFixed(2)
          metrics.broad_cir = +metrics.broad_gmv ? +(+metrics.cost * 100 / +metrics.broad_gmv).toFixed(1) : 0
          metrics.broad_roi = +metrics.cost ? +(+metrics.broad_gmv / +metrics.cost).toFixed(1) : 0
          metrics.atosa_cpc = +metrics.click ? this.m__calculate(+metrics.cost / +metrics.click) : 0
          if (type === 'homepage_report') {
            this.total_metrics = metrics
            this.total_reports = resp.data.data[type]
          }
          if (type === 'search_report') {
            this.search_ads_metrics = metrics
            this.search_ads_reports = resp.data.data[type]
          }
          if (type === 'discovery_report') {
            this.targeting_ads_metrics = metrics
            this.targeting_ads_reports = resp.data.data[type]
          }
          if (type === 'boost_report') {
            this.boost_ads_metrics = metrics
            this.boost_ads_reports = resp.data.data[type]
          }
        }
      }

      if (this.ads_version === 'new') {
        const keys = ['new_cpc_homepage', 'product_homepage', 'shop_homepage']
        for (const key of keys) {
          await this.sleep(1000)
          const report_response = await this.seller.marketing_get_time_graph(key, this.dayjs(start_time).startOf('day').unix(), this.dayjs(end_time).endOf('day').unix(), {})
          if (report_response.data) {
            this[key + '_metrics'] = map_graph_response(report_response.data.report_aggregate)
            this[key + '_reports'] = map_graph_by_time_response(report_response.data.report_by_time)
          }
        }
      }
    },

    async m__get_ads_metrics_compare(start_time, end_time) {
      if (this.ads_version === 'new') {
        const keys = ['new_cpc_homepage', 'product_homepage', 'shop_homepage']
        for (const key of keys) {
          await this.sleep(1000)
          const report_response = await this.seller.marketing_get_time_graph(key, this.dayjs(start_time).startOf('day').unix(), this.dayjs(end_time).endOf('day').unix(), {})
          if (report_response.data) {
            this[key + '_metrics_compare'] = map_graph_response(report_response.data.report_aggregate)
          }
        }
      }
    },

    async m__download_excel_file() {
      if (this.start_time && this.end_time) {
        let start_time = this.start_time
        let end_time = this.end_time - 1000
        if (this.period === 'month') {
          end_time = this.dayjs(new Date(end_time * 1000)).endOf('month').add(1, 'second').unix()
        }

        const resp = await this.seller.dashboard_export(start_time, end_time, this.period)
        const bytes = new Uint8Array(resp.data)
        const url = window.URL.createObjectURL(new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${this.shop.username}.shopee-shop-stats.${this.dayjs(this.start_time * 1000).format('YYYY-MM-DD')}-${this.dayjs(this.end_time * 1000).subtract(1, 's').format('YYYY-MM-DD')}.xlsx`)
        document.body.appendChild(link)
        link.click()
      }
    },

    async m__download_pas_ads_report(type) {
      this.loading.export_report = true
      const start_time = this.ads_start_time
      const end_time = this.dayjs(this.ads_end_time * 1000).endOf('day').unix()

      const trigger_response = await this.seller.marketing_pas_report_trigger_or_get_previous({
        start_time,
        end_time,
        header: {},
        report_type: `${type}__overall`
      })
      if (trigger_response && trigger_response.data && trigger_response.data.export_id) {
        const { export_id } = trigger_response.data

        let report_result = await this.seller.marketing_pas_report_get_single_result(export_id)
        while (report_result && report_result.data && ['waiting', 'processing'].includes(report_result.data.status)) {
          await this.sleep(1000)
          report_result = await this.seller.marketing_pas_report_get_single_result(export_id)
        }

        if (report_result && report_result.data && report_result.data.status === 'success') {
          const download_response = await this.seller.marketing_pas_report_download(export_id)
          const anchor = document.createElement('a')
          anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(download_response.data.content)
          anchor.target = '_blank'
          anchor.download = `${this.shop.username}.-${download_response.data.file_name}.csv`
          anchor.click()
        } else {
          this.ntf_w(this.$t('ads.error_with_exporting'))
        }
      } else {
        this.ntf_w(this.$t('ads.error_with_exporting'))
      }

      this.loading.export_report = false
    },

    m__calculate_metric(type) {
      let metrics = {}
      if (this.selected_tab === 'new_cpc_homepage') metrics = this.new_cpc_homepage_metrics
      if (this.selected_tab === 'product_homepage') metrics = this.product_homepage_metrics
      if (this.selected_tab === 'shop_homepage') metrics = this.shop_homepage_metrics
      if (this.selected_tab === 'all') metrics = this.total_metrics
      if (this.selected_tab === 'keyword_ads') metrics = this.search_ads_metrics
      if (this.selected_tab === 'targeting_ads') metrics = this.targeting_ads_metrics
      if (this.selected_tab === 'boost_ads') metrics = this.boost_ads_metrics

      if (type === 'CPS' && metrics.cost && metrics.broad_order) {
        return this.m__calculate(metrics.cost / metrics.broad_order)
      }
      if (type === 'CPC' && metrics.cost && metrics.click) {
        return this.m__calculate(metrics.cost / metrics.click)
      }
      if (type === 'CIR' && metrics.cost && metrics.broad_gmv) {
        return (metrics.cost * 100 / metrics.broad_gmv).toFixed(2)
      }

      return '0.00'
    },

    async m__get_composition_buyers(start_time, end_time, period, order_type) {
      const resp = await this.seller.get_composition_buyers(start_time, end_time, period, order_type)
      this.composition_buyers = resp.data.result

      const buyers_types = ['new_buyers', 'existing_buyers']
      for (const type of buyers_types) {
        const temp = this.composition_buyers.find(i => i.buyers_type === type)
        if (temp) {
          this[type] = this.clone(temp)
          console.log(this[type])
        }
      }
    },

    async m__get_composition_pricezone(start_time, end_time, period, order_type) {
      const resp = await this.seller.get_composition_pricezone(start_time, end_time, period, order_type)
      // console.log(resp.data)
      this.composition_pricezone = resp.data.result
    },

    async get_overview_funnel(start_time, end_time, period) {
      const resp = await this.seller.get_overview_funnel(start_time, end_time, period)
      this.overview_funnel = resp.data.result
    },

    async get_overview_funnel_compare(start_time, end_time, period) {
      const resp = await this.seller.get_overview_funnel(start_time, end_time, period)
      this.overview_funnel_compare = resp.data.result
    },

    async get_traffic_overview(start_time, end_time, period) {
      let dt = this.dayjs(end_time * 1000).format('YYYYMMDD')
      if (this.dayjs(end_time * 1000).isSameOrAfter(this.dayjs(), 'd')) {
        dt = this.dayjs().subtract(1, 'd').format('YYYYMMDD')
      }
      const resp = await this.seller.get_traffic_overview(dt, period)
      if (resp && resp.data && resp.data.code === 0) {
        this.new_followers = resp.data.result.data.all.new_followers
      }
    },

    async get_traffic_overview_compare(start_time, end_time, period) {
      let dt = this.dayjs(end_time * 1000).format('YYYYMMDD')
      if (this.dayjs(end_time * 1000).isSameOrAfter(this.dayjs(), 'd')) {
        dt = this.dayjs().subtract(1, 'd').format('YYYYMMDD')
      }
      const resp = await this.seller.get_traffic_overview(dt, period)
      if (resp && resp.data && resp.data.code === 0) {
        this.new_followers_compare = resp.data.result.data.all.new_followers
      }
    },

    async m__get_metrics_customer(start_time, end_time, period, order_type) {
      const type = order_type ? order_type : 'placed'
      const resp = await this.seller.get_metrics_customer(start_time, end_time, period, type)
      this.metrics_customer = resp.data
      console.log(this.metrics_customer)
    },

    async m__get_metrics_customer_compare(start_time, end_time, period, order_type) {
      const type = order_type ? order_type : 'placed'
      const resp = await this.seller.get_metrics_customer(start_time, end_time, period, type)
      this.metrics_customer_compare = resp.data
    },

    async m__get_product_performance(start_time, end_time, period) {
      this.product_performance = []

      let page = 1, page_size = 20
      let product_performance_resp = await this.seller.get_product_performance_main(page, page_size, start_time, end_time, period)

      while (product_performance_resp && product_performance_resp.data && product_performance_resp.data.result && product_performance_resp.data.result.items && product_performance_resp.data.result.items.length) {
        if (this.product_performance.length > product_performance_resp.data.result.total) {
          return
        }

        const query_ids = new Set()
        for (const item of product_performance_resp.data.result.items) {
          item.pv_to_add_to_cart_rate = +item.pv ? parseFloat((item.add_to_cart_units / item.pv * 100).toFixed(2)) : 0
          item.uv_to_add_to_cart_rate = +item.pv ? parseFloat((item.add_to_cart_units / item.uv * 100).toFixed(2)) : 0
          item.add_to_cart_to_placed_units_rate = +item.add_to_cart_units ? parseFloat((item.placed_units / item.add_to_cart_units * 100).toFixed(2)) : 0
          item.add_to_cart_to_paid_units_rate = +item.add_to_cart_units ? parseFloat((item.paid_units / item.add_to_cart_units * 100).toFixed(2)) : 0
          item.add_to_cart_to_confirmed_units_rate = +item.add_to_cart_units ? parseFloat((item.confirmed_units / item.add_to_cart_units * 100).toFixed(2)) : 0
          item.stock = 0
          item.checked = false
          item.compare = null

          const item_id = item.id.toString()
          if (!this.product_detail_cache[item_id]) query_ids.add(item_id)
        }

        // todo: query product stock
        if (this.allow_get_stock && query_ids.size > 0) {
          const products_detail = await this.seller.get_product_by_graphql([...query_ids])
          if (products_detail && products_detail.data && products_detail.data.products && products_detail.data.products.items && products_detail.data.products.items.length) {
            for (const item of products_detail.data.products.items) {
              this.product_detail_cache[item.itemid] = item
            }
          }
          await this.sleep(1000)
        }

        for (const item of product_performance_resp.data.result.items) {
          item.stock = this.product_detail_cache[item.id.toString()]
              ? this.product_detail_cache[item.id.toString()].normalStock
              : 0
        }

        this.product_performance.push(...product_performance_resp.data.result.items)
        page++
        product_performance_resp = await this.seller.get_product_performance_main(page, page_size, start_time, end_time, period)
      }
      this.product_performance = _uniqBy(this.product_performance, 'id')

      for (const item of this.product_performance_compare) {
        const found = this.product_performance.find(i => i.id === item.id)
        if (found) {
          found.compare = _pick(item, ['pv', 'uv', 'add_to_cart_units', 'placed_units', 'placed_sales', 'confirmed_units', 'confirmed_sales', 'paid_units', 'paid_sales', 'pv_to_add_to_cart_rate', 'uv_to_add_to_cart_rate', 'add_to_cart_to_placed_units_rate', 'add_to_cart_to_paid_units_rate', 'add_to_cart_to_confirmed_units_rate'])
        }
      }
      this.product_performance = this.clone(this.product_performance)
    }
  }
}
</script>

<style lang="scss">
.gmv-table {
  strong, td {
    font-size: 15px;
    line-height: 25px;
    font-weight: 600;
  }
}
</style>

<style>
.important-box {
  min-height: 120px;
  box-shadow: 0 1px 4px 0 rgb(0 0 0 / 12%);
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  padding: 10px 4px 10px 7px;
  background: #fff;
  cursor: pointer;
}

.circle {
  margin-right: 5px;
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-bottom: 1px;
}

.key_metrics_compare {
  font-size: 12px !important;
}

.key_metrics_compare:before {
  content: '\25B8 \0020';
}
</style>



// WEBPACK FOOTER //
// src/pages/center/data_center.vue